const ENABLE_LOGS = true;

interface LogOptions {
	isError?: boolean;
}

export function log(message?: unknown, ...optionalParams: unknown[]): void;
export function log(options: LogOptions, message?: unknown, ...optionalParams: unknown[]): void;
export function log(...args: unknown[]): void {
	if (!ENABLE_LOGS) return;

	let isError = false;

	if (typeof args[0] === "object" && args[0] !== null && "isError" in args[0]) {
		const opts = args.shift() as LogOptions;
		isError = !!opts.isError;
	}

	const prefix = isError ? "🔴" : "🟢";

	if (isError) {
		console.error(prefix, ...args);
	} else {
		console.log(prefix, ...args);
	}
}
